<template>
  <div>
    <vs-text>Logging out...</vs-text>
    <iframe
      v-if="externalRequest === false && !isFetching"
      class="d-none"
      sandbox="allow-scripts allow-same-origin"
      :src="adminPortalUrl"
      @load="handleLogout"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { useActions } from 'vuex-composition-helpers'
import { getInstance } from '@/auth/auth.js'
import { useRoute } from 'vue-router/composables'
import { computed, onMounted } from 'vue'
import { getAdminPortalConfig } from '@/api/config'
import moment from 'moment'
import { useQuery } from '@tanstack/vue-query'

const route = useRoute()
const auth = getInstance()

let loggingOut = false

const { terminateNotifications } = useActions('notifications', ['terminateNotifications'])

const externalRequest = !!route.query.externalRequest
const { data: config, isFetching } = useQuery({
  queryKey: ['config'],
  queryFn: getAdminPortalConfig,
  cacheTime: Infinity,
  staleTime: moment.duration(1, 'days').asMilliseconds(),
})
const adminPortalUrl = computed(() => {
  if (config.value) {
    return `${config.value.data.url}/auth0logout`
  }
  return ''
})

onMounted(() => {
  sessionStorage.clear()

  if (externalRequest) {
    handleLogout()
  } else {
    setTimeout(handleLogout, 3000)
  }
})

function handleLogout(): void {
  if (loggingOut) return
  loggingOut = true

  terminateNotifications().finally(auth.logout)
  setTimeout(auth.logout, 3000)
}
</script>
